import { Enrollment } from '@clear-denver/tpc-openapi-typescript'

interface ErrorMessage {
  key: string
  errorMessage: string
}

export const getGlobalErrorMessage = (errors: any) => {
  return errors?.global?.length ? errors?.global[0].errorMessage : undefined
}

export const createGlobalErrorMessage = (e: any) => {
  const globalError = {
    global: [
      {
        key: 'global',
        errorMessage: e.message,
      },
    ],
  }
  return globalError
}

export interface ErrorsByProperty {
  [key: string]: Array<ErrorMessage>
}

export const getApiErrorsByProperty = (
  errors: Array<Enrollment.ServiceError>,
  formState: { [key: string]: any }
): ErrorsByProperty => {
  const errorsByProperty = errors.reduce((acc: any, err: any) => {
    const formKeys = Object.keys(formState)
    const errorKey = formKeys.includes(err.property) ? err.property : 'global'
    if (!acc[errorKey]) acc[errorKey] = []
    acc[errorKey].push({
      key: err.property,
      errorMessage: err.message,
    })
    return acc
  }, {})

  return errorsByProperty
}

export async function extractErrors(
  error: Response,
  data: any
): Promise<ErrorsByProperty>
export async function extractErrors(
  error: Error,
  data: any
): Promise<ErrorsByProperty>
export async function extractErrors(error: any, data: any) {
  try {
    const errorBody = await error.json()
    return getApiErrorsByProperty(
      errorBody.errors || errorBody.businessErrors,
      data
    )
  } catch {
    return createGlobalErrorMessage(error)
  }
}

export function setFormErrors<T>(
  errorsByProperty: ErrorsByProperty,
  setError: T
) {
  Object.keys(errorsByProperty).forEach((errorKey) => {
    typeof setError === 'function' &&
      setError(errorKey, {
        message: errorsByProperty[errorKey][0].errorMessage,
      })
  })
}
